// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2YreS","emails":"CreateEditClinics_emails__25XY5","emailTagLabel":"CreateEditClinics_emailTagLabel__1lnZW"};